"use client";
import { brokerConnectModalAtom } from "@/Atoms/modal/DialogueAtoms";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

function BrokerConnectButton({ link, id }: { link?: boolean; id?: string }) {
  const [showConnectForm, setShowConnectForm] = useRecoilState(
    brokerConnectModalAtom
  );
  const { t } = useTranslation("layout-page");

  return (
    <div
      id="connect-to-broker-deploy-live2"
      className={
        "w-full text-xs whitespace-wrap cursor-pointer flex flex-col gap-0 items-start justify-start max-h-[80px]"
      }
      onClick={() => {
        setShowConnectForm({ isOpen: true });
      }}
    >
      <div className="flex items-center px-0.5">
        <div id={id} className="flex items-center cursor-pointer">
          <div className="w-[10px] h-[10px] rounded-xl bg-[--marketplace-red]"></div>
          <div>
            <p className="text-muted-foreground text-xs font-bold ml-2 whitespace-nowrap">
              {t("Broker Not Connected")}
            </p>
          </div>
        </div>
      </div>

      <div className="flex font-bold text-sm text-muted-foreground items-center gap-2">
        <p className="flex w-full items-center h-[25px] justify-start gap-2 font-bold text-xs text-[--marketplace-red]">
          <span className="text-[--marketplace-red] text-[14px] font-semibold">
            {t("Click to connect now")}
          </span>
        </p>
      </div>
    </div>
  );
}

export default BrokerConnectButton;
